<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <div class="card mt-n3">
    <div class="card-body">
      <div class="row g-2">
        <div class="col-sm-4" style="display: none;">
          <div class="search-box">
            <input type="text" class="form-control" placeholder="Search for name, tasks, projects or something...">
            <i class="ri-search-line search-icon"></i>
          </div>
        </div>
        <!--end col-->
        <div class="col-sm-auto ms-auto">
          <div class="list-grid-nav hstack gap-1" ngbDropdown>
            <ul ngbNav #Border="ngbNav" [activeId]="1" class="d-flex gap-1">
              <li [ngbNavItem]="1">
                <a ngbNavLink class="btn btn-soft-primary nav-link btn-icon filter-button btn-sm">
                  <i class="ri-grid-fill fs-16"></i>
                </a>

                <ng-template ngbNavContent>
                  <div class="team-list grid-view-filter row">
                    <div class="col" *ngFor="let data of propertyAgentsData">
                      <div class="card-height-100 card team-box">
                        <div class="team-cover">
                          <img src="assets/images/small/img-6.jpg" alt="" class="img-fluid" />
                        </div>

                        <div class="card-body p-4">
                          <div class="row align-items-center team-row">
                            <div class="col team-settings">
                              <div class="row">
                                <div class="col">
                                  <div class="bookmark-icon flex-shrink-0 me-2">
                                    <button *ngIf="data.isMain" type="button"
                                      ngbTooltip="{{'t-properties-agents.t-main-agent' | translate}}" container="body"
                                      class="active me-2 btn btn-icon btn-light btn-sm favourite-btn rounded-circle">
                                      <i class="ri-star-fill fs-14"></i>
                                    </button>
                                    <button *ngIf="data.isListingAgent" type="button"
                                      ngbTooltip="{{'t-properties-agents.t-listing-agent' | translate}}"
                                      container="body"
                                      class="active btn btn-icon btn-light btn-sm favourite-btn rounded-circle">
                                      <i class="fs-20 mdi mdi-home-group-plus"></i>
                                    </button>
                                    <button *ngIf="data.isSellingAgent && property?.saleInProgress" type="button"
                                      ngbTooltip="{{'t-proposals.t-selling-agent' | translate}}" container="body"
                                      [ngClass]="{'ms-2': data.isMain || data.isListingAgent}"
                                      class="active btn btn-icon btn-light btn-sm favourite-btn rounded-circle">
                                      <i class="fs-20 mdi mdi-handshake"></i>
                                    </button>
                                  </div>
                                </div>
                                <div class="col text-end dropdown" ngbDropdown
                                  *ngIf="(!permissionsService.isAgent(loginUser.role?.name) && !property) || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property))">
                                  <a href="javascript:void(0);" class="arrow-none" id="dropdownMenuLink2"
                                    ngbDropdownToggle>
                                    <i class="ri-more-fill fs-17"></i>
                                  </a>
                                  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink2"
                                    ngbDropdownMenu>
                                    <li><a class="dropdown-item" href="javascript:void(0);"
                                        (click)="deleteAgentToProperty(data)"><i
                                          class="ri-delete-bin-5-line me-2 align-middle"></i>
                                        {{ 't-delete' | translate }}
                                      </a>
                                    </li>
                                    <li
                                      *ngIf="!data.isMain  && ((!permissionsService.isAgent(loginUser.role?.name) && !property) || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)))">
                                      <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="changeMainAgent(data)"><i
                                          class="mdi mdi-check-circle-outline me-2 align-middle"></i>
                                        {{'t-mark-as-main' | translate}}</a>
                                    </li>
                                    <li
                                      *ngIf="!data.isListingAgent  && !isStoreOperatorAgent(data) && ((!permissionsService.isAgent(loginUser.role?.name) && !property) || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property))) && !property?.saleInProgress">
                                      <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="changeListingAgent(data)"><i
                                          class="mdi mdi-check-circle-outline me-2 align-middle"></i>
                                        {{'t-properties-agents.t-mark-as-listing'
                                        | translate}}</a>
                                    </li>
                                    <li
                                      *ngIf="data.isListingAgent && ((!permissionsService.isAgent(loginUser.role?.name) && !property) || (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property))) && !property?.saleInProgress">
                                      <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="removeListingAgent(data)"><i
                                          class="mdi mdi-close-circle-outline fs-15 me-2 align-middle"></i>
                                        {{'t-properties-agents.t-unmark-as-listing'
                                        | translate}}</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-4 col">
                              <div class="team-profile-img">
                                <div class="avatar-lg img-thumbnail rounded-circle flex-shrink-0"
                                  *ngIf="data?.agentFile">
                                  <img
                                    [src]="data.agentFile?.length > 0 ? pathProfileImage+data.agentFile: 'assets/images/users/user-dummy-img.jpg'"
                                    class="rounded-circle img-fluid userprofile" alt="">
                                </div>
                                <div class="avatar-lg img-thumbnail rounded-circle flex-shrink-0"
                                  *ngIf="!data?.agentFile">
                                  <div class="avatar-title bg-soft-danger text-danger rounded-circle">
                                    {{ data.name.charAt(0) }}</div>
                                </div>
                                <div class="team-content">
                                  <a data-bs-toggle="offcanvas" aria-controls="offcanvasExample"
                                    (click)="onTeamButtonClicked()">
                                    <h5 class="fs-16 mb-1">{{data.name}}</h5>
                                  </a>
                                  <p class="text-muted mb-0">
                                    {{ 't-m-properties.t-agent' | translate }}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-4 col">
                              <div class="row text-muted text-center">
                                <div
                                  [ngClass]="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && data?.isListingAgent && (data?.listingCommission || data?.listingCommission == 0) && !property?.saleInProgress ? 'col-4' : 'col-6'"
                                  class="border-end border-end-dashed">
                                  <h5 class="mb-1">{{data.totalProperties}}</h5>
                                  <p class="text-muted mb-0">
                                    {{ 't-m-properties.t-properties' | translate }}
                                  </p>
                                </div>
                                <div
                                  [ngClass]="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && data?.isListingAgent && (data?.listingCommission || data?.listingCommission == 0) && !property?.saleInProgress ? 'col-4 border-end border-end-dashed' : 'col-6'">
                                  <h5 class="mb-1">{{data.totalSales}}</h5>
                                  <p class="text-muted mb-0">
                                    {{'t-m-properties.t-sales' | translate }}
                                  </p>
                                </div>
                                <div
                                  *ngIf="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && data?.isListingAgent && (data?.listingCommission || data?.listingCommission == 0) && !property?.saleInProgress"
                                  (click)="openInpt(data?.listingCommission, data?.id)"
                                  [ngClass]="{'opened': openInput === data?.id}" class="col-4 commission-area">
                                  <h5 *ngIf="!openInput || openInput !== data?.id"
                                    ngbTooltip="{{'t-properties-agents.t-click-for-change' | translate}}" class="mb-1">
                                    {{data?.listingCommission}}%</h5>
                                  <div class="position-relative" *ngIf="openInput && openInput === data?.id">
                                    <div class="btns d-flex justify-content-between w-100 position-absolute">
                                      <button
                                        (click)="childrenClick($event); data.listingCommission = bkpValue; openInput = null"
                                        class="btn badge-soft-danger"><i class="mdi mdi-close"></i></button>
                                      <button (click)="childrenClick($event); openInput = null"
                                        class="btn badge-soft-success"><i class="mdi mdi-check-all"></i></button>
                                    </div>
                                    <input mask="separator" thousandSeparator=" " suffix="%" type="text"
                                      [(ngModel)]="data.listingCommission" class="form-control">
                                  </div>
                                  <p class="text-muted mb-0">
                                    {{'t-properties-agents.t-commission' |
                                    translate}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--end card-->
                    </div>
                    <!--end col-->
                  </div>
                  <!--end row-->
                </ng-template>
              </li>

              <li [ngbNavItem]="2">
                <a ngbNavLink class="btn btn-soft-primary nav-link  btn-icon filter-button btn-sm">
                  <i class="ri-list-unordered fs-16"></i>
                </a>

                <ng-template ngbNavContent>
                  <div class="team-list list-view-filter row">
                    <div class="col" *ngFor="let data of propertyAgentsData">
                      <div class="card team-box">
                        <div class="team-cover">
                          <img src="assets/images/small/img-6.jpg" alt="" class="img-fluid" />
                        </div>

                        <div class="card-body p-4">
                          <div class="row align-items-center team-row">
                            <div class="col team-settings">
                              <div class="row">
                                <div class="col">
                                  <div class="bookmark-icon flex-shrink-0 me-2">
                                    <input type="checkbox" id="favourite1" class="bookmark-input bookmark-hide">
                                    <label for="favourite1" class="btn-star">
                                      <svg width="20" height="20">
                                        <use xlink:href="#icon-star" />
                                      </svg>
                                    </label>
                                  </div>
                                </div>

                                <div class="col text-end dropdown" ngbDropdown
                                  *ngIf="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property))">
                                  <a href="javascript:void(0);" class="arrow-none" id="dropdownMenuLink2"
                                    data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                                    <i class="ri-more-fill fs-17"></i>
                                  </a>

                                  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink2"
                                    ngbDropdownMenu>
                                    <li><a class="dropdown-item" href="javascript:void(0);"
                                        (click)="deleteAgentToProperty(data)"><i
                                          class="ri-delete-bin-5-line me-2 align-middle"></i>{{
                                        't-delete' | translate }}</a>
                                    </li>

                                    <li
                                      *ngIf="!data.isMain && (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property))">
                                      <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="changeMainAgent(data)"><i
                                          class="mdi mdi-check-circle-outline me-2 align-middle"></i>
                                        {{'t-mark-as-main' | translate}}</a>
                                    </li>

                                    <li
                                      *ngIf="!data.isListingAgent && !isStoreOperatorAgent(data) && (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && !property?.saleInProgress">
                                      <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="changeListingAgent(data)"><i
                                          class="mdi mdi-check-circle-outline me-2 align-middle"></i>
                                        {{'t-properties-agents.t-mark-as-listing' | translate}}</a>
                                    </li>

                                    <li
                                      *ngIf="!data.isListingAgent  && (permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && !property?.saleInProgress">
                                      <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="removeListingAgent(data)"><i
                                          class="mdi mdi-close-circle-outline fs-15 me-2 align-middle"></i>
                                        {{'t-properties-agents.t-unmark-as-listing' | translate}}</a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col">
                              <div class="team-profile-img">
                                <div class="avatar-lg img-thumbnail rounded-circle flex-shrink-0"
                                  *ngIf="data?.agentFile">
                                  <img
                                    [src]="data.agentFile?.length > 0 ? pathProfileImage+data.agentFile: 'assets/images/users/user-dummy-img.jpg'"
                                    class="rounded-circle img-fluid userprofile" alt="">
                                </div>
                                <div class="avatar-lg img-thumbnail rounded-circle flex-shrink-0"
                                  *ngIf="!data?.agentFile">
                                  <div class="avatar-title bg-soft-danger text-danger rounded-circle">
                                    {{ data.name.charAt(0) }}</div>
                                </div>
                                <div class="team-content">
                                  <a [ngClass]="{'d-flex': data.isMain || data.isListingAgent}"
                                    data-bs-toggle="offcanvas" aria-controls="offcanvasExample"
                                    (click)="onTeamButtonClicked()">
                                    <h5 class="fs-16 mb-1">{{data.name}}</h5>
                                    <div *ngIf="data.isMain" class="bookmark-icon flex-shrink-0 ms-3">
                                      <button type="button"
                                        class="active btn btn-icon btn-light btn-sm favourite-btn rounded-circle">
                                        <i class="ri-star-fill fs-14"></i>
                                      </button>
                                    </div>
                                    <div *ngIf="data.isListingAgent" class="bookmark-icon flex-shrink-0 ms-3">
                                      <button type="button"
                                        class="active btn btn-icon btn-light btn-sm favourite-btn rounded-circle">
                                        <i class="mdi mdi-home-group-plus fs-14"></i>
                                      </button>
                                    </div>
                                  </a>
                                  <p class="text-muted mb-0">
                                    {{ 't-m-properties.t-agents' | translate }}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-4 col">
                              <div class="row text-muted text-center">
                                <div
                                  [ngClass]="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && data?.isListingAgent && (data?.listingCommission || data?.listingCommission == 0) ? 'col-4' : 'col-6'"
                                  class="border-end border-end-dashed">
                                  <h5 class="mb-1">{{data.totalProperties}}</h5>
                                  <p class="text-muted mb-0">
                                    {{ 't-m-properties.t-properties' | translate }}
                                  </p>
                                </div>

                                <div
                                  [ngClass]="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && data?.isListingAgent && (data?.listingCommission || data?.listingCommission == 0) ? 'col-4 border-end border-end-dashed' : 'col-6'">
                                  <h5 class="mb-1">{{data.totalSales}}</h5>
                                  <p class="text-muted mb-0">
                                    {{ 't-m-properties.t-sales' | translate }}
                                  </p>
                                </div>

                                <div
                                  *ngIf="(permissionsService.canEditProperty(loginUser, property?.store?.id) || permissionsService.canEditPropertyWithoutAgent(property)) && data?.isListingAgent && (data?.listingCommission || data?.listingCommission == 0)"
                                  (click)="openInpt(data?.listingCommission, data?.id)"
                                  [ngClass]="{'opened': openInput === data?.id}" class="col-4 commission-area">
                                  <h5 *ngIf="!openInput || openInput !== data?.id"
                                    ngbTooltip="{{'t-properties-agents.t-click-for-change' | translate}}" class="mb-1">
                                    {{data?.listingCommission}}%</h5>
                                  <div class="position-relative" *ngIf="openInput && openInput === data?.id">
                                    <div class="btns d-flex justify-content-between w-100 position-absolute">
                                      <button
                                        (click)="childrenClick($event); data.listingCommission = bkpValue; openInput = null"
                                        class="btn badge-soft-danger"><i class="mdi mdi-close"></i></button>
                                      <button (click)="childrenClick($event); openInput = null"
                                        class="btn badge-soft-success"><i class="mdi mdi-check-all"></i></button>
                                    </div>
                                    <input mask="separator" thousandSeparator=" " suffix="%" type="text"
                                      [(ngModel)]="data.listingCommission" class="form-control">
                                  </div>
                                  <p class="text-muted mb-0">
                                    {{'t-properties-agents.t-commission' |
                                    translate}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--end card-->
                    </div>
                    <!--end col-->
                  </div>
                  <!--end row-->
                </ng-template>
              </li>
            </ul>

            <button class="btn btn-outline-primary waves-effect waves-primary btn-sm" (click)="openModal(content)"
              *ngIf="(permissionsService.canEditProperty(loginUser, property?.store?.id, !property ? true : false, property ? property?.mainAgent : null) || permissionsService.canEditPropertyWithoutAgent(property))">
              <i class="ri-add-fill me-1 align-bottom"></i>
              {{ 't-add-agent' | translate }}
            </button>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div>
        <div [ngbNavOutlet]="Border"></div>

        <!-- Modal -->
        <ng-template #content role="document" let-modal>
          <div class="modal-header p-3 ps-4 bg-soft-primary">
            <h5 class="modal-title" id="inviteMembersModalLabel">
              {{ 't-m-properties.t-agents' | translate }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              (click)="modal.dismiss('Cross click')"></button>
          </div>
          <div class="modal-body p-4">
            <div class="search-box mb-3">
              <input type="text" class="form-control bg-light border-light"
                placeholder=" {{ 't-search' | translate }}  {{ 't-here' | translate }}..." [formControl]="queryField">
              <i class="ri-search-line search-icon"></i>
            </div>
            <div class="mb-4 d-flex align-items-center">
              <div class="me-2" *ngIf="propertyAgentsData?.length !== 0">
                <h5 class="mb-0 fs-13">
                  {{ 't-m-properties.t-agents-added-on-property' | translate }}:
                </h5>
              </div>
              <div class="avatar-group justify-content-center" *ngIf="propertyAgentsData?.length > 0">
                <a href="javascript: void(0);" class="avatar-group-item" data-bs-toggle="tooltip"
                  data-bs-trigger="hover" data-bs-placement="top" title="{{data.name}}"
                  *ngFor="let data of propertyAgentsData">
                  <div class="avatar-xs">
                    <img
                      [src]="data.agentFile?.length > 0 ? pathProfileImage+data.agentFile: 'assets/images/users/user-dummy-img.jpg'"
                      alt="" class="rounded-circle img-fluid">
                  </div>
                </a>
              </div>
            </div>
            <ngx-simplebar class="mx-n4 px-4" style="max-height: 225px;">
              <div class="vstack gap-3">
                <div class="d-flex align-items-center" *ngFor="let data of agentsAvailableForProperty">
                  <div class="avatar-xs flex-shrink-0 me-3">
                    <img
                      [src]="data.agentFile != '' ? pathProfileImage+data.agentFile: 'assets/images/users/user-dummy-img.jpg'"
                      alt="" class="img-fluid rounded-circle">
                  </div>
                  <div class="flex-grow-1">
                    <h5 class="fs-13 mb-0"><a href="javascript: void(0);" class="text-body d-block">{{data.name}}</a>
                    </h5>
                  </div>
                  <div class="flex-shrink-0" *ngIf="!data.add">
                    <button type="button" class="btn btn-light btn-sm" (click)="addAgentToProperty(data)">
                      {{ 't-m-properties.t-add-on-property' | translate }}
                    </button>
                  </div>
                  <div class="flex-shrink-0" *ngIf="data.add">
                    <button type="button" class="btn btn-light btn-sm" (click)="deleteAgentToProperty(data)">
                      {{ 't-m-properties.t-remove-form-property' | translate }}
                    </button>
                  </div>
                </div>
                <!-- end member item -->
              </div>
              <!-- end list -->
            </ngx-simplebar>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
                        (click)="modal.close('Close click')">Cancel</button> -->
            <button type="button" class="btn btn-primary w-xs" (click)="modal.dismiss()">
              {{ 't-close' | translate }}
            </button>
          </div>
        </ng-template>

        <!--end offcanvas-->
        <div class="team-overlay" (click)="SidebarHide()"></div>
      </div>
    </div><!-- end col -->
  </div>
  <!--end row-->
</ngx-simplebar>
